//import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createLoadScreen: FBRTypes.CreateLoadScreenFunction = (
	/*backgroundTexture: PIXI.Texture,
	startButtonTexture: PIXI.Texture,
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	globalState: MutableRefObject<FBRTypes.GlobalState>,*/
) => {
	let loadedValue = 0;
	const loadScreenContainer = new PIXI.Container();
	const loadingBarContainer = new PIXI.Container();
	const loadingText = new PIXI.Text(
		`Loading ${loadedValue}%`, 
		{ 
			fontFamily : 'Arial', 
			fontSize: 26, 
			fill : 0xffffff, 
			align : 'center' 
		}
	);
	loadingText.anchor.set(0.5, 0.5);
	loadingText.x = FBRConstants.STAGE_WIDTH/2;
	loadingText.y = FBRConstants.STAGE_HEIGHT/3 + 50;

	loadScreenContainer.addChild(loadingText);	
	loadScreenContainer.addChild(loadingBarContainer);	

	const _update = () => {
		loadingText.text = `Loading ${loadedValue}%`;
		const loadingBar = new PIXI.Graphics();
		const loadingBarWidth = FBRConstants.STAGE_WIDTH - FBRConstants.STAGE_WIDTH/5;
		const loadingBarHeight = 25;
		const loadingBarX = FBRConstants.STAGE_WIDTH/10;
		const loadingBarY = FBRConstants.STAGE_HEIGHT/2 - loadingBarHeight/2 - 50;
		loadingBar.beginFill(0x076da0);
		loadingBar.drawRect(
			loadingBarX,
			loadingBarY,
			loadingBarWidth*(loadedValue/100), 
			loadingBarHeight
		);
		loadingBar.endFill();
		loadingBarContainer.removeChildren();
		loadingBarContainer.addChild(loadingBar);
	}

	const _setLoadedValue = (newValue: number) => {
		loadedValue = newValue;
	}

	const _destroy = () => {
		loadScreenContainer.destroy();
	}
	
	return {
		container: loadScreenContainer,
		update: _update,
		setLoadedValue: _setLoadedValue,
		destroy: _destroy,
	};
};

export default createLoadScreen;
